import * as React from 'react';
import Package from '../package/Package';
import classNames from 'classnames';

import './Products.css';

export interface Props {
  products: endpoints.ProductDTO[];
}

interface State {
  smallColumnSize: number;
  mediumColumnSize: number;
  largeColumnSize: number;
}

export class Products extends React.PureComponent<Props, State> {

  maxSmallCols = 1;
  maxMediumCols = 2;
  maxLargeCols = 3;

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.setupState(props)
    };
  }

  componentDidUpdate(props: Props) {
    this.setState(this.setupState(props));
  }

  setupState = (props: Props) => {
    const numProducts = props.products.length;
    return {
      smallColumnSize: this.maxSmallCols,
      mediumColumnSize: this.calculateColumns(numProducts, this.maxMediumCols),
      largeColumnSize: this.calculateColumns(numProducts, this.maxLargeCols)
    };
  }

  calculateColumns(numProducts: number, maxColumns: number) {
    if (numProducts > maxColumns) {
      return maxColumns;
    } else {
      return numProducts;
    }
  }

  renderColumns = () => {
    return this.props.products.map((product, index) => (
      <div
        data-testid={`product-item-${product.productId}`}
        key={product.productId}
        className="l-columns__column"
      >
        <Package productId={product.productId} />
      </div>
    ));
  }

  render() {
    const { smallColumnSize, mediumColumnSize, largeColumnSize } = this.state;
    const classes = classNames(
      'products-container',
      'l-columns',
      `l-columns--${smallColumnSize}-small`,
      `l-columns--${mediumColumnSize}-medium`,
      `l-columns--${largeColumnSize}-large`
    );

    return (
      <div data-testid="product-container" className={classes}>
        {this.renderColumns()}
      </div>
    );
  }
}